import styled from 'styled-components';
import { backgroundColors, body2, spacing } from 'ui/theme';

export const Cell = styled.div<{ columnId: string; $rowIndex: number }>`
  grid-column: col-${({ columnId }) => columnId} / span 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${body2};
  padding: ${spacing.base} ${spacing.plusHalf};
  background-color: ${({ $rowIndex }) =>
    $rowIndex % 2 === 1 && $rowIndex !== undefined && backgroundColors.backgroundSecondary};
`;
